import React, { useState, useEffect, useRef } from "react";
import arrow_down_red from "../../../../src/assets/ArrowsIcons/arrow_down_white_filled.svg";
import "./index.css";

export const BeneMonthYearSelect = ({
  ddlValue,
  optionalLabel,
  isFieldRequired,
  fieldname,
  handleInputChange,
  data_type,
  type,
  title,
  selectedValue,
  setSelectedValue,
  setShowDatePicker,
}) => {
  const [dropdownOpen, setdropdownOpen] = useState(false);

  function getMonthNumber(monthName) {
    const months = {
      January: 1,
      February: 2,
      March: 3,
      April: 4,
      May: 5,
      June: 6,
      July: 7,
      August: 8,
      September: 9,
      October: 10,
      November: 11,
      December: 12,
    };

    const formattedName = monthName?.trim()?.toLowerCase();
    const monthNumber = Object?.entries(months).find(
      ([name]) => name.toLowerCase() === formattedName
    );

    return monthNumber ? monthNumber[1] : null;
  }

  useEffect(() => {
    if (selectedValue?.month !== "Select" && selectedValue?.year !== "Select") {
      handleInputChange({
        target: {
          name: fieldname,
          value: `${getMonthNumber(selectedValue?.month)}/${
            selectedValue?.year
          }`,
          data_typeChan: data_type,
        },
      });
    }
  }, [selectedValue]);

  const handleSelect = (val) => {
    if (title === "Month") {
      setSelectedValue({ ...selectedValue, month: val });
    } else if (title === "Year") {
      setSelectedValue({ ...selectedValue, year: val });
    }

    setdropdownOpen(false);
  };

  const dropdownRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current?.contains(event.target)) {
        setdropdownOpen(false);
      }
    }

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-[100%]" ref={dropdownRef}>
      <div
        className="headerText"
        id="uploadId"
        style={{
          color:
            selectedValue?.month !== "Select" &&
            selectedValue?.year !== "Select"
              ? "#F9F9F9"
              : "#f9f9f9",
        }}
      >
        {`${title}${isFieldRequired ? "*" : ""}${optionalLabel}`}
      </div>
      <div
        className={`selectDrp shadow-lg ${dropdownOpen ? "open" : ""}`}
        onClick={() => {
          setShowDatePicker(false);
          setdropdownOpen(!dropdownOpen);
        }}
      >
        <div className="selectDrp_select">
          <span
            style={{
              color:
                selectedValue?.month === "Select" ||
                ("" && selectedValue?.year === "Select") ||
                ""
                  ? "#DADADA"
                  : "#f9f9f9",
            }}
          >
            {title === "Month" ? selectedValue?.month : selectedValue?.year}
          </span>
          <img
            src={arrow_down_red}
            alt="down"
            style={{
              transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </div>
        <div
          className="selectDrp_scroll_line"
          style={{ display: dropdownOpen ? "block" : "none" }}
        ></div>

        {dropdownOpen && (
          <div className="scroll_content shadow-lg cursor-pointer">
            {type ? (
              <ul>
                {ddlValue.map((val, index) => (
                  <li
                    key={`rd${index}`}
                    className="category-wrapper"
                    onClick={() => handleSelect(val, fieldname, data_type)}
                  >
                    <label>{val}</label>
                    <input
                      type={type}
                      name="quantity"
                      onChange={() => handleSelect(val, fieldname, data_type)}
                      required={isFieldRequired}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              ddlValue.map((val, index) => (
                <div
                  key={`rd${index}`}
                  className="category-wrapper"
                  onClick={() => handleSelect(val, fieldname, data_type)}
                >
                  {val}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BeneMonthYearSelect;
